//
// Main Nav functions
//
export default class MainNav {
  constructor() {

    // Mobile nav dropdown elements
    this.mobileNav = document.getElementById('js-menu-container');
    this.mobileNavTrigger = document.getElementById('js-site-header__mobile-nav-trigger');

    if (!this.mobileNav) return;

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
   togglemobileNav(event) {
    event.preventDefault();

    const open = JSON.parse(this.mobileNavTrigger.getAttribute('aria-expanded'));
    this.mobileNavTrigger.setAttribute('aria-expanded', !open);

    this.mobileNavTrigger.classList.toggle('site-header__mobile-nav-trigger--open');
    this.mobileNav.classList.toggle('site-nav--open');

    document.body.classList.toggle('modal-open');
  }

  addEventHandling() {
    this.mobileNavTrigger.addEventListener('click', this.togglemobileNav.bind(this));
  }
}